import TextInput from '/src/components/UI/TextField/TextInput';
import { useEffect, useState } from 'react';
import editorAction from '../../../actions/editorAction';
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
// Simple Component for all the form, thanks to him we can edit easialy the title fo a block
function TitleBlock({name, title, titleInput, placeholderInput, id, callback}) {

    const toast = useToastDispatchContext();

    const [value, setValue] = useState(name);

    const { updateBlockName } = editorAction();

    const updateTitle =  (e) => {
        if(e.target.value == name) return;
        updateBlockName(id, value);
        callback(value)
    }

    const copyToClipBoard = async (e) => {
        const url = `${location.protocol}//${location.host}${location.pathname}?#${id}`
        await navigator.clipboard.writeText(url);
        toast.success('Share your block to help debug' , `The Url of sharing is copied`, 5000);
    }

    useEffect(() => setValue(name), [name])
    
    return (
        <>
            <div className="title">
                <span>{title}</span>
                <span className="icon" onClick={copyToClipBoard}></span>
            </div>
            <label className="input_title">{titleInput}</label>
            <TextInput placeholder={placeholderInput} onBlur={updateTitle} className="editor-input title_input" value={value} onChange={(e) => setValue(e.target.value)}/>
        </>
    )

}

TitleBlock.defaultProps = {
    placeholderInput : 'Block Name',
    callback : () => {}

}

export default TitleBlock;
